/**
 * 新版本提示条（15b，两端同一套）。
 *
 * 顶部覆盖层（不挤文档流）：聊天页/列表页都可能挂着它，挤高度会让虚拟列表
 * 重算；它是短暂的，覆盖更合适。移动端贴状态栏下方（standalone 下
 * black-translucent 内容延伸到状态栏，必须加 safe-area-inset-top）。
 *
 * standalone 下这是用户唯一的刷新入口（没地址栏、没下拉刷新），所以按钮一定
 * 要在；关闭只在本次会话内生效（store 的 dismissed），自动时机不受影响。
 */
import { useGlobal } from '~/store/useGlobal';
import { swUpdate } from '~/store/swUpdate';
import { selectUpdateBannerVisible } from '~/store/swUpdateState';
import styles from './updateBanner.module.scss';
import { IconClose } from '~/ui/icons';

export function UpdateBanner() {
  const visible = useGlobal(selectUpdateBannerVisible);
  const applying = useGlobal((s) => s.swUpdate.applying);
  if (!visible) return null;
  return (
    <div className={styles.bar} data-testid="update-banner" role="status">
      <span className={styles.text}>{applying ? '正在更新…' : '新版本已就绪'}</span>
      <button
        type="button"
        className={styles.apply}
        data-testid="update-apply"
        disabled={applying}
        onClick={() => swUpdate().apply()}
      >
        立即刷新
      </button>
      <button
        type="button"
        className={styles.close}
        data-testid="update-dismiss"
        aria-label="关闭"
        onClick={() => swUpdate().dismiss()}
      >
        <IconClose class={styles.closeGlyph} />
      </button>
    </div>
  );
}
